@if (currentState$ | async; as currentState) {
  <div class="grid-process-column">
    <engine-process-current-state [processState]="currentState"
    (executeProcessTransition)="executeTransition($event)" />
  </div>
}
